import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import shop from './modules/shop'
import user from './modules/user'
import order from './modules/order'
import app from './modules/app'
import search from './modules/search'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    shop, user, order, app, search
  },
  getters,
  plugins: [createPersistedState()]
})
export default store
